<template>
    
    <v-dialog 
        v-model="display" 
        width="500" 
        persistent
    >
        <MessageOverlay ref="overlay"/>

            <v-card>
                <v-card-title class="text-h5">{{ $vuetify.lang.t('$vuetify.account.changePhoneNumber.phonechange') }}</v-card-title>
                <v-card-text class="pb-0">
                    <v-form ref="formEditPhone" v-model="phoneFormValidation" lazy-validation>
                         <vue-tel-input-vuetify
                            outlined
                            clearable
                            placeholder=""
                            appendIcon="$dropdown"
                            mode="international"
                            type="tel"
                            v-model="newPhoneValue"
                            :label="phoneInputLabel"
                            :select-label="countryInputLabel"
                            :valid-characters-only="true"
                            @input="onTelephoneInput"
                        ></vue-tel-input-vuetify>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        :disabled="!phoneFormValidation || !isPhoneValid"
                        :class="!phoneFormValidation || !isPhoneValid ? '' : 'gradient-wintech'"
                        @click="savePhone"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        {{ $vuetify.lang.t('$vuetify.account.changePhoneNumber.save') }}
                    </v-btn>
                    <v-btn
                        color="error"
                        @click="cancelPhoneDialog"
                    >
                        <v-icon left>mdi-cancel</v-icon>
                        {{ $vuetify.lang.t('$vuetify.account.changePhoneNumber.cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>
<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import MessageOverlay from '@/components/Overlay/MessageOverlay.vue'

export default {
    name: "ChangePhoneNumber",
    components: {MessageOverlay},
    props: {
        display: Boolean,
    },
    data() {
        return {
            newPhoneValue: "",
            phone: {
                number: "",
                valid: false,
            },
            phoneFormValidation: true,
        };
    },

    methods: {
        ...mapActions(["SetUser"]),
        async created() {
        },
        async savePhone() {
            if (this.$refs.formEditPhone.validate()  && this.isPhoneValid) {
                let data = Object.assign({}, this.user);
                data.token = this.token;
                data.phone = this.phone.valid ? this.phone.number : "";
                try {
                    const res = await axios.put('users/changePhone', {phone: data.phone, email: this.user.email});
                    if (res.status == 200) {
                        await this.SetUser(data);
                        this.$refs.formEditPhone.reset();
                        this.$emit("valid");
                    }
                } catch(error) {
                    this.$refs.overlay.showOverlay("error", error);
                }
            }
        },
        onTelephoneInput(formattedNumber, { number, valid }) {
            this.phone.number = "e164" in number ? number.e164 : number.input;
            this.newPhoneValue = "international" in number ? number.international : number.input;
            this.phone.valid = valid;
        },

        cancelPhoneDialog() {
            this.$refs.formEditPhone.reset();
            this.$emit("cancel");
        },
    },
    computed: {
        ...mapGetters({ user: "StateUser", token: "StateToken"}),
        countryInputLabel() {
            return this.$vuetify.lang.t('$vuetify.account.changePhoneNumber.country') ;
        },
        phoneInputLabel() {
            return this.$vuetify.lang.t('$vuetify.account.changePhoneNumber.phonenumber') ;
        },
        isPhoneValid() {
            return (this.newPhoneValue === '' || this.phone.valid)
        }

    }
};
</script>